export default "__VITE_ASSET__DghheGaD__"